var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-cell',{attrs:{"title":"昵称","value":_vm.user.name || _vm.user.phoneNum}}),_c('van-cell',{attrs:{"title":"手机号码","value":_vm.user.phoneNum}}),_c('van-cell',{attrs:{"title":"修改密码","is-link":"","to":"/updatePwd"}}),_c('div',{staticClass:"exit mt20"},[_c('van-cell',{attrs:{"title":"退出登录"},on:{"click":_vm.loginOut}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }